import styles from "./DatasetSnapshots.module.scss";
import { SnapshotIcon } from "./Icons";
import { useVisibility } from "../../../../hooks/useVisibility";
import { Drawer } from "antd";
import { DatasetSnapshots } from "./DatasetSnapshots";
import { useSelector } from "react-redux";
import { getCreationStatus } from "../../../../redux/CreateDataset/selectors";
import { SyncOutlined } from "@ant-design/icons";
import VLTooltip from "../../../uikit/VLTooltip";

export const DatasetSnapshotsButton = ({
  className,
  datasetId,
}: {
  datasetId: string;
  className?: string;
}) => {
  const drawerVisibility = useVisibility();
  const creationStatus = useSelector(getCreationStatus);
  return (
    <>
      <VLTooltip title="Snapshots">
        <div
          className={className}
          data-testid="snapshot-btn"
          onClick={drawerVisibility.open}
        >
          {creationStatus?.taskType === "SNAPSHOT_RESTORE" ? (
            <SyncOutlined className={styles.spinIcon} spin />
          ) : (
            <SnapshotIcon />
          )}
        </div>
      </VLTooltip>
      <Drawer
        classNames={{ body: styles.drawer }}
        closable={false}
        open={drawerVisibility.isOpen}
        onClose={drawerVisibility.close}
      >
        <DatasetSnapshots
          datasetId={datasetId}
          onClose={drawerVisibility.close}
        />
      </Drawer>
    </>
  );
};
